import { Box, Card, CardHeader, CardTable } from '@forgeglobal/design-framework'
import React, { Fragment } from 'react'

import { OpportunityFormCard, OpportunityFormCardProps } from './OpportunityFormCard'
import { OpportunityFragment } from 'graphql/bindings/AdminBindings'

export interface OpportunityFormCardsProps {
  type: string
  opportunities: OpportunityFragment[]
  filter: string
  refetchOnCancelMutation?: OpportunityFormCardProps['refetchOnCancelMutation']
}

const columnDefs = [
  {
    name: 'company_name',
    label: 'Issuer',
    minWidth: 75,
  },
  {
    name: 'size_or_shares',
    label: 'Size/Shares',
    minWidth: 175,
  },
  {
    name: 'price_or_valuation',
    label: 'Price/Valuation',
    minWidth: 150,
  },
  {
    name: 'fee',
    label: 'Fee',
    minWidth: 100,
  },
  {
    name: 'last_renewed',
    label: 'Last renewed',
    minWidth: 100,
    priority: 2,
  },
  {
    name: 'status',
    label: 'Status',
    minWidth: 100,
    priority: 2,
  },
  {
    name: 'entity',
    label: 'Entity',
    minWidth: 150,
    priority: 3,
  },
  {
    name: 'structure',
    label: 'Structure',
    minWidth: 150,
    priority: 3,
  },
  {
    name: 'certainty',
    label: 'Certainty',
    minWidth: 125,
    priority: 4,
  },
  {
    name: 'owners',
    label: 'Owners',
    minWidth: 200,
    priority: 5,
  },
  {
    name: 'createDealButton',
    label: 'Deal',
    minWidth: 175,
    isLabelHidden: true,
    fixedSize: true,
  },
  {
    name: 'notes',
    label: 'Notes',
    minWidth: 24,
    isLabelHidden: false,
    fixedSize: true,
  },
]

export const OpportunityFormCards: React.FC<OpportunityFormCardsProps> = ({
  type,
  opportunities,
  filter,
  refetchOnCancelMutation,
}) => {
  return (
    <Fragment>
      <Box mt={4}>
        <CardTable colDefs={columnDefs} header={`${filter} ${type}s`}>
          {opportunities.map(opportunity => (
            <OpportunityFormCard
              key={opportunity.id}
              opportunity={opportunity}
              tableVariant={'account'}
              refetchOnCancelMutation={refetchOnCancelMutation}
            />
          ))}
          {!opportunities.length && (
            <Card>
              <CardHeader title="None" />
            </Card>
          )}
        </CardTable>
      </Box>
    </Fragment>
  )
}
